<!--
 * @Descripttion: 联系我们模块
 * @Author: zcy
 * @Date: 2021-12-22 16:25:52
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-01-14 14:00:11
-->
<template>
  <div class="contactus">
    <!-- 主题内容盒子 -->
    <ContentBox
      class="contactus-content-box"
      :title="$t('contactus.title')"
    >
      <div class="contactus-main">
        <div class="img-page">
          <div
            :key="index"
            v-for="(item, index) in LogoDataList"
            class="logo-img-box"
          >
            <img
              :src="item.detailsPicture | OSSUrl"
              lazy-load
            />
          </div>
        </div>
      </div>
    </ContentBox>
  </div>
</template>

<script>
import http from "../../axios/index.js";
import ContentBox from "../../components/content-box.vue";
export default {
  name: "contactus",
  components: {
    ContentBox,
  },
  watch: {
    "$i18n.locale": {
      handler(newName, oldName) {
        let lang = "";
        switch (newName) {
          case "zh":
            lang = "zh_CN";
            break;
          case "en":
            lang = "en";
            break;
          default:
            break;
        }
        this.getInfo(lang);
      },
      immediate: true,
    },
  },
  data() {
    return {
      title: "",
      LogoDataList: [],
    };
  },
  mounted() {},
  methods: {
    getInfo(lang) {
      this.initContactusData(lang);
    },
    // 初始化函数
    initContactusData(lang) {
      http
        .get(`/frontContactUs/${lang}`)
        .then((res) => {
          this.LogoDataList = res.data;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style lang="less" scoped>
// 路由出口定位内容盒子布局
.contactus {
  width: 100%;
  height: 100%;
  position: relative;

  .contactus-content-box {
    .contactus-main {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 13rem;
      padding-left: 19.67rem;
      padding-right: 2.17rem;
      padding-bottom: 9.5rem;

      .img-page {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        padding-right: 18rem;
        box-sizing: border-box;
        overflow: auto;

        .logo-img-box {
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
